import { Callout } from "../components/Callout.js";
import { ScreenshotBox } from "../components/ScreenshotBox.js";

export const meta = {
  title: "HubSpot との接続",
  updatedAt: "2026-05-22",
};

export function Content() {
  return (
    <>
      <p>
        Sign Extension は HubSpot ポータルと連携することで、
        <strong>取引・会社・コンタクトレコード内のプロパティ</strong>の取得や書き込みを
        行います。このページでは、初回接続の流れと、接続済みポータルの管理方法を説明します。
      </p>

      <h2>初回接続（アカウント登録時）</h2>
      <p>
        初回の HubSpot 接続は、当サービスへのアカウント登録の流れの中で行われます。
      </p>
      <ol>
        <li>
          <a href="https://cs.hsextension.com/register">https://cs.hsextension.com/register</a>{" "}
          から登録ページを開きます
        </li>
        <li>
          会社名・氏名・E メール・HubSpot 利用状況を入力して登録します
        </li>
        <li>
          続けて HubSpot の承認画面に遷移します。連携したい HubSpot ポータルを
          選択し、「<strong>アプリを接続する</strong>」をクリックします
        </li>
        <li>
          自動的に当サービスのダッシュボードへ戻り、接続完了です
        </li>
      </ol>
      <ScreenshotBox src="/guide/screenshots/hubspot-connect-1.png" caption="HubSpot 承認画面" />

      <Callout type="warning" title="HubSpot 管理者権限が必要">
        HubSpot 側の承認操作は <strong>HubSpot 管理者権限</strong>を持つアカウントで
        行う必要があります。一般ユーザー権限では承認できません。
      </Callout>

      <h2>接続状況の確認</h2>
      <p>
        接続済みのポータル情報は、ダッシュボード上部のヘッダーに表示されています
        （ポータル名と Portal ID）。
      </p>
      <ScreenshotBox src="/guide/screenshots/hubspot-connect-2.png" caption="ヘッダーの接続情報表示" />

      <h2>別のポータルに切り替える（再接続）</h2>
      <p>
        誤ったポータルで接続してしまった、別のポータルに移行したい、などの理由で
        接続先を変更する場合は「<strong>接続設定</strong>」タブを開きます。
      </p>
      <p>
        「HubSpot 接続」セクションにある「<strong>再接続（アカウント変更）</strong>」
        ボタンをクリックすると、HubSpot 承認画面が再度開きます。
        別のポータルを選択して接続し直してください。
      </p>

      <Callout type="warning" title="再接続による影響">
        別のポータルに切り替えると、当サービス上のテナント（送信履歴・設定・
        Client ID 等）はそのまま保持されますが、これまでに送信した書類のステータス
        同期先が新しいポータルに変わります。元のポータルのレコードへの書き込みは
        止まります。
      </Callout>

      <h2>CRM カードが表示されないとき</h2>
      <p>
        HubSpot と接続できても、取引・会社・コンタクトの画面に「クラウドサイン」
        カードが自動で表示されないことがあります。表示方法は次の 2 通りです。
      </p>
      <ol>
        <li>
          <strong>レコード詳細画面から追加する</strong>: 任意の取引・会社・コンタクトの
          詳細画面を開き、右上の「<strong>カスタマイズ</strong>」→ 該当タブで
          「クラウドサイン」カードを追加します
        </li>
        <li>
          <strong>アプリ設定ページから追加する</strong>: HubSpot の「設定」→
          「アプリ」→ 接続済みのアプリ一覧から「Sign Extension for クラウドサイン」を
          選び、カードの表示設定を有効化します
        </li>
      </ol>

      <Callout type="info" title="HubSpot プラン">
        本サービスの CRM カードは <strong>HubSpot のすべてのプラン</strong>でご利用いただけます。
        Free プランの View-Only Seat の利用者もカードを開き、書類送信を実行できます。
      </Callout>
    </>
  );
}
